import React from "react";
import {ReactComponent as NotFoundLogo} from '../../resources/images/error_404.svg';
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import './NotFoundPage.css';

export class NotFoundPage extends React.Component<any, any> {

    componentDidMount(){
        GoogleTagManagerService.getInstance().pushGenericError('Questa pagina non esiste', '404', 'Not found');
    }
   
    render(){
        return <div id={"main-container-not-found"}>
            <div className={"not-found-logo-container"}>
                <NotFoundLogo className={"not-found-logo"}/>
            </div>
            <p className={"not-found-text"}>Questa pagina non esiste</p>
        </div>
    }

}